export const TREND_ASSETS_CHECKBOXES = [
  { value: 'FA090', color: '#006AA6', isBarChart: true },
  { value: 'BS250', color: '#C3D785', isBarChart: true },
  { value: 'BS265', color: '#E3A2A7', isBarChart: true },
  { value: 'BS36', color: '#AE93E1', isBarChart: true },
  { value: 'BS46', color: '#00A8B5', isBarChart: true },
  { value: 'BS49', color: '#74B49A', isBarChart: true },
  { value: 'FA091', color: '#7F63B9', isBarChart: true },
  { value: 'RT0172', color: '#F49966', isLineChart: true },
]

export const TREND_LIABILITIES_CHECKBOXES = [
  { value: 'BS66', color: '#006AA6', isBarChart: true },
  { value: 'BS81', color: '#C3D785', isBarChart: true },
  { value: 'FA099', color: '#F49966', isLineChart: true },
]

export const TREND_EQUITY_CHECKBOXES = [
  { value: 'BS293', color: '#006AA6', isBarChart: true },
  { value: 'BS294', color: '#C3D785', isBarChart: true },
  { value: 'BS138', color: '#E3A2A7', isBarChart: true },
  { value: 'BS109', color: '#AE93E1', isBarChart: true },
  { value: 'FA102', color: '#00A8B5', isBarChart: true },
  { value: 'RT0173', color: '#F49966', isLineChart: true },
]

export const EACH_YEAR = {
  ASSETS: [
    { id: 'FA154', color: '#006AA6' },
    { id: 'FA092', color: '#F49966' },
    { id: 'FA093', color: '#00A8B5' },
    { id: 'FA094', color: '#D96383' },
    { id: 'FA095', color: '#74B49A' },
    { id: 'FA096', color: '#7F63B9' },
    { id: 'FA097', color: '#E3A2A7' },
    { id: 'FA098', color: '#FFCD60' },
  ],
  PARENT_PIE: [
    { id: 'BS65', color: '#0553A5' },
    { id: 'BS95', color: '#FFCD60' },
  ],
  CHILD_PIE: {
    BS65: [
      { id: 'FA100', color: '#4EB1CB' },
      { id: 'FA101', color: '#F49966' },
    ],
    BS95: [
      { id: 'FA103', color: '#4EB1CB' },
      { id: 'FA104', color: '#F49966' },
      { id: 'FA105', color: '#717ECD' },
      { id: 'FA106', color: '#C3D785' },
      { id: 'FA107', color: '#EC838C' },
    ],
  },
}

export const TABLE_TABS = [
  {
    label: 'financialAnalysis.ASSET_STRUCTURE',
    key: 0,
    rowIds: [
      'FA090',
      'BS250',
      'BS265',
      'BS36',
      'BS46',
      'BS49',
      'FA091',
      'BS64',
      'RT0172',
    ],
  },
  {
    label: 'financialAnalysis.LIABILITIES_STRUCTURE',
    key: 1,
    rowIds: ['BS66', 'BS81', 'BS65', 'FA099'],
  },
  {
    label: 'financialAnalysis.EQUITY_STRUCTURE',
    key: 2,
    rowIds: ['BS293', 'BS294', 'BS138', 'BS109', 'FA102', 'BS95', 'RT0173'],
  },
]
